module.exports = __webpack_public_path__ + "img/prevArrow.636afab0.svg";